import Vue from "vue";
import uuidv4 from "uuid/v4";
import { Cache } from "aws-amplify";

const dashboard = {
  state: {
    dashboardDrawer: Cache.getItem("dashboardDrawer")
      ? !!+Cache.getItem("dashboardDrawer")
      : true,
    seletFilterDialogVisible: false,
    addOrEditFilterDialogVisible: false,
    saveQueryDialogVisible: false,
    filters: [],
    queries: [],
    snapshots: []
  },

  mutations: {
    TOGGLE_DASHBOARD_DRAWER: state => {
      state.dashboardDrawer = !state.dashboardDrawer;
      if (state.dashboardDrawer) {
        Cache.setItem("dashboardDrawer", 1);
      } else {
        Cache.setItem("dashboardDrawer", 0);
      }
    },
    SET_ADD_OR_EDIT_FILTER_DIALOG_VISIBLE: (state, value) => {
      state.addOrEditFilterDialogVisible = value;
    },
    SET_SELECT_FILTER_DIALOG_VISIBLE: (state, value) => {
      state.seletFilterDialogVisible = value;
    },
    SET_SAVE_QUERY_DIALOG_VISIBLE: (state, value) => {
      state.saveQueryDialogVisible = value;
    },
    ADD_FILTER: (state, filter) => {
      state.filters.push(filter);
    },
    UPDATE_FILTER: (state, filter) => {
      var index = state.filters.findIndex(({ uuid }) => uuid === filter.uuid);
      let item = Object.assign({}, filter);
      Vue.set(state.filters, index, item);
    },
    DELETE_FILTER: (state, filter) => {
      var idx = state.filters.findIndex(({ uuid }) => uuid === filter.uuid);
      Vue.delete(state.filters, idx);
    },
    DELETE_FILTERS: (state, selected) => {
      if (selected) {
        //console.log(`Tiene ${selected.length}  elementos seleccionados`);
        //console.log(selected);
        selected.forEach(function(item, index) {
          console.log("eliminando item index: " + index);
          var idx = state.filters.findIndex(({ uuid }) => uuid === item.uuid);
          Vue.delete(state.filters, idx);
        });
        selected = [];
        //console.log(`Tiene ${selected.length}  elementos seleccionados`)
      } else {
        console.log(`Se han eliminado `);
        state.filters = [];
      }
    },
    SET_FILTERS: (state, filters) => {
      state.filters = filters;
    },
    SET_QUERIES: (state, queries) => {
      state.queries = queries;
    },
    ADD_SNAPSHOT: (state, snapshot) => {
      state.snapshots = [];
      state.snapshots.push(snapshot);
    },
    RESTORE_SNAPSHOT: (state, snapshot) => {
      console.log("RESTORE_SNAPSHOT", snapshot);
      state.filters = state.snapshot[0].filters;
      state.snapshot = snapshot;
    }
  },
  actions: {
    toggleDashBoardDrawer({ commit }) {
      console.log("action: toggleDashBoardDrawer");
      commit("TOGGLE_DASHBOARD_DRAWER");
    },
    showSelectFilterDialog({ commit }) {
      console.log("action: showSelectFilterDialog");
      commit("SET_SELECT_FILTER_DIALOG_VISIBLE", true);
    },
    hideSelectFilterDialog({ commit }) {
      console.log("action: hideSelectFilterDialog");
      commit("SET_SELECT_FILTER_DIALOG_VISIBLE", false);
    },
    showAddOrEditFilterDialog({ commit }) {
      console.log("action: showAddOrEditFilterDialog");
      commit("SET_ADD_OR_EDIT_FILTER_DIALOG_VISIBLE", true);
    },
    hideAddOrEditFilterDialog({ commit }) {
      console.log("action: hideAddOrEditFilterDialog");
      commit("SET_ADD_OR_EDIT_FILTER_DIALOG_VISIBLE", false);
    },
    showSaveQueryDialog({ commit }) {
      console.log("action: showSaveQueryDialog");
      commit("SET_SAVE_QUERY_DIALOG_VISIBLE", true);
    },
    hideSaveQueryDialog({ commit }) {
      console.log("action: hideSaveQueryDialog");
      commit("SET_SAVE_QUERY_DIALOG_VISIBLE", false);
    },
    addFilterAction({ commit }, payload) {
      payload.uuid = uuidv4();
      payload.selected = false;
      let item = Object.assign({}, payload);
      console.log(payload);
      /* Vue.prototype.$Amplify.Analytics.record({
        name: "addFilter",
        attributes: {filterName: payload.}
      }); */
      commit("ADD_FILTER", item);
    },
    updateFilterAction({ commit }, item) {
      commit("UPDATE_FILTER", item);
    },
    deleteFilterAction({ commit }, item) {
      commit("DELETE_FILTER", item);
    },
    deleteFiltersAction({ commit }, selected) {
      commit("DELETE_FILTERS", selected);
    },
    setFiltersAction({ commit }, filters) {
      commit("SET_FILTERS", filters);
    },
    setQueriesAction({ commit }, queries) {
      console.log("action: setQueriesAction", queries);
      commit("SET_QUERIES", queries);
    },
    deleteQueryAction({ commit }, uuid) {
      commit("DELETE_QUERY", uuid);
    },
    //Snapshots
    addSnapshotAction({ commit }, snapshot) {
      console.log("addSnapshotAction");
      commit("ADD_SNAPSHOT", snapshot);
    },
    restoreSnapshotAction({ commit }) {
      console.log("restoreSnapshotAction");
      commit("RESTORE_SNAPSHOT");
    }
  }
};

export default dashboard;
